import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import HomeAction from '../offline/actions/HomeAction'
import { getPayload } from '../../utils/ActionUtils'

const checkAuth = (logout) => {
    const payload = getPayload()
    if (!payload) {
        return false
    } else if (moment().isAfter(moment(JSON.parse(payload).exp))) {
        logout()
        return false
    }
    return true
}

const AuthRoute = (props) => {
    return checkAuth(props.logout) ? <props.component {...props} /> : <Redirect to='/login' />
}

const mapDispatchToProps = {
    logout: HomeAction.logout,
}

AuthRoute.propTypes = {
    path: PropTypes.string,
    logout: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(AuthRoute)
